// removed by extract-text-webpack-plugin
module.exports = {"sticky-bottom-bar":"StickyBottomBar__sticky-bottom-bar","stickyBottomBar":"StickyBottomBar__sticky-bottom-bar","shadowed":"StickyBottomBar__shadowed"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/StickyBottomBar/StickyBottomBar.css
// module id = 1415
// module chunks = 8